// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__28AjF","rootSmall":"AddTileButton_rootSmall__2L9zo"};